import React from "react";
import { Link } from "react-router-dom";
import "./TableRow.css";
import useEventOddsSocket from "../../hooks/useEventOddsSocket";

const TableRow = ({ i, row, isMobile, username }) => {
  const socketUsername =
    username !== undefined &&
    username !== null &&
    String(username).trim() !== ""
      ? String(username)
      : "guest";

  const liveMarket = useEventOddsSocket(row?.event_id, socketUsername);
  const getDisplayDate = () => {
    if (!row.open_date) return "";
    const openDateObj = new Date(row.open_date);
    const today = new Date();
    const tomorrow = new Date(today);
    today.setHours(0, 0, 0, 0);
    tomorrow.setDate(today.getDate() + 1);
    tomorrow.setHours(0, 0, 0, 0);

    if (openDateObj.toDateString() === today.toDateString()) return "Today";
    if (openDateObj.toDateString() === tomorrow.toDateString())
      return "Tomorrow";

    return openDateObj.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  };

  const getDisplayTime = () => {
    if (!row.open_date) return "";
    const openDateObj = new Date(row.open_date);
    return openDateObj.toLocaleTimeString([], {
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: false,
    });
  };

  // ==================== DYNAMIC ODDS LOGIC (REVISED & ROBUST) ====================
  // const placeholderOdd = {
  //   price: "0",
  //   size: "",
  // };

  // const liveMarketTypes =
  //   liveMarket?.market_types || liveMarket?.marketTypes || [];

  // const matchOddsMarket = liveMarketTypes.find((market) => {
  //   const marketName = String(market?.market_name || market?.marketName || "")
  //     .trim()
  //     .toLowerCase();

  //   return marketName === "match odds" || marketName === "match_odds";
  // });

  // const marketRunners =
  //   matchOddsMarket?.runners || matchOddsMarket?.marketRunners || [];

  // const backOdds = [];
  // const layOdds = [];

  // for (let index = 0; index < 3; index++) {
  //   const runner = marketRunners[index];

  //   if (!runner) {
  //     backOdds.push({
  //       ...placeholderOdd,
  //     });

  //     layOdds.push({
  //       ...placeholderOdd,
  //     });

  //     continue;
  //   }

  //   backOdds.push({
  //     price: runner.back_1_price ?? runner.backPrice ?? "0",

  //     size: runner.back_1_size ?? runner.backSize ?? "",
  //   });

  //   layOdds.push({
  //     price: runner.lay_1_price ?? runner.layPrice ?? "0",

  //     size: runner.lay_1_size ?? runner.laySize ?? "",
  //   });
  // }

  // const odds = [...backOdds, ...layOdds];
  // ==============================================================================

  // ==================== SIX MARKET-DEPTH ODDS ====================
  const liveMarketTypes =
    liveMarket?.market_types || liveMarket?.marketTypes || [];

  const matchOddsMarket = liveMarketTypes.find((market) => {
    const marketName = String(market?.market_name || market?.marketName || "")
      .trim()
      .toLowerCase();

    return marketName === "match odds" || marketName === "match_odds";
  });

  const marketRunners =
    matchOddsMarket?.runners || matchOddsMarket?.marketRunners || [];

  // Single UpcomingEvents row mein
  // first runner ka complete depth.
  const selectedRunner = marketRunners[0] || null;

  const createOdd = (price, size, type, level) => ({
    price: price !== undefined && price !== null && price !== "" ? price : "0",

    size: size !== undefined && size !== null && size !== "" ? size : "",

    type,
    level,
  });

  // MatchUpdates order:
  // Back-3, Back-2, Back-1,
  // Lay-1, Lay-2, Lay-3
  const odds = selectedRunner
    ? [
        createOdd(
          selectedRunner.back_3_price,
          selectedRunner.back_3_size,
          "back",
          3,
        ),

        createOdd(
          selectedRunner.back_2_price,
          selectedRunner.back_2_size,
          "back",
          2,
        ),

        createOdd(
          selectedRunner.back_1_price,
          selectedRunner.back_1_size,
          "back",
          1,
        ),

        createOdd(
          selectedRunner.lay_1_price,
          selectedRunner.lay_1_size,
          "lay",
          1,
        ),

        createOdd(
          selectedRunner.lay_2_price,
          selectedRunner.lay_2_size,
          "lay",
          2,
        ),

        createOdd(
          selectedRunner.lay_3_price,
          selectedRunner.lay_3_size,
          "lay",
          3,
        ),
      ]
    : [
        {
          price: "0",
          size: "",
          type: "back",
          level: 3,
        },
        {
          price: "0",
          size: "",
          type: "back",
          level: 2,
        },
        {
          price: "0",
          size: "",
          type: "back",
          level: 1,
        },
        {
          price: "0",
          size: "",
          type: "lay",
          level: 1,
        },
        {
          price: "0",
          size: "",
          type: "lay",
          level: 2,
        },
        {
          price: "0",
          size: "",
          type: "lay",
          level: 3,
        },
      ];
  // ==============================================================

  const teamNames = row?.event_name?.split(" v ") || ["Team A", "Team B"];
  const linkTo = `/matchupdates/${row.event_id}/${row.is_inplay === "True" ? "Inplay" : "Going Inplay"}`;

  return (
    <Link to={linkTo} className="block">
      <div className="grid grid-cols-12 border-t border-border_color_primary1 h-12 bg-bg_color_primary items-center w-full">
        {/* Date/Time or In-Play */}
        <div className="col-span-2 flex flex-col items-center justify-center px-1 text-[9px] font-medium text-center text-text_color_InPlayEventsScoreAndTime min-h-9 active:scale-[94%] transition-all ease-in-out duration-100">
          {row.is_inplay === "True" ? (
            <div style={{ marginRight: "8px" }}>
              <span
                className="cool-link"
                style={{
                  display: "inline-block",
                  color: "#29ab2b",
                  textDecoration: "none",
                  position: "relative",
                  fontSize: "11px",
                }}
              >
                LIVE
              </span>
            </div>
          ) : (
            <>
              <span>{getDisplayDate()}</span>
              <span>{getDisplayTime()}</span>
            </>
          )}
        </div>

        {/* Team Names */}
        <div className="col-span-4 flex flex-col justify-center px-1 border-l border-r border-border_color_primary text-[11px] font-bold text-text_color_primary1 truncate transition-transform active:scale-[94%] relative min-w-0">
          <div className="flex flex-col w-[87%]">
            <div className="flex items-center">
              <span className="w-[5px] h-[5px] p-[1px] mr-[2px]"></span>
              <span className="truncate">{teamNames[0]}</span>
            </div>
            <div className="flex items-center">
              <span className="w-[5px] h-[5px] p-[1px] mr-[2px]"></span>
              <span className="truncate">{teamNames[1]}</span>
            </div>
          </div>
          <span className="absolute top-0.5 right-0.5">
            <svg
              width="13"
              height="11"
              viewBox="0 0 13 11"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M11.8182 0H1.18182C0.525909 0 0 0.543889 0 1.22222V8.55556C0 9.22778 0.525909 9.77778 1.18182 9.77778H4.13636V11H8.86364V9.77778H11.8182C12.4682 9.77778 12.9941 9.22778 12.9941 8.55556L13 1.22222C13 0.543889 12.4682 0 11.8182 0ZM11.8182 8.55556H1.18182V1.22222H11.8182V8.55556ZM8.86364 4.88889L4.72727 7.33333V2.44444L8.86364 4.88889Z"
                fill="var(--icon-color-primary1)"
              />
            </svg>
          </span>
        </div>

        {/* Odds */}
        {/* Six odds: Back-3, Back-2, Back-1, Lay-1, Lay-2, Lay-3 */}
        {/* Odds */}
        <div className="col-span-6 w-full h-full min-w-0">
          {isMobile ? (
            /* MOBILE:
       First page = 3 Back
       Scroll right = 3 Lay
    */
            <div
              id="hideScrollBar"
              className="w-full h-full flex overflow-x-auto overflow-y-hidden snap-x snap-mandatory scroll-smooth"
            >
              {/* Mobile Back Page */}
              <div className="min-w-full w-full h-full grid grid-cols-3 gap-x-[1px] px-[1px] py-[1px] snap-start">
                {odds.slice(0, 3).map((odd, index) => (
                  <div
                    key={`mobile-back-${odd.level}-${index}`}
                    className="w-full h-full min-w-0"
                  >
                    <div className="overflow-hidden relative w-full h-full px-1 py-[1px] rounded-sm flex flex-col items-center justify-center bg-bg_color_backBtnBg text-text_color_oddValue">
                      <span className="flex items-center justify-center w-full leading-5 text-sm font-semibold truncate">
                        {odd.price}
                      </span>

                      <span className="flex items-center justify-center w-full text-[9px] leading-3 text-center truncate">
                        {odd.size}
                      </span>
                    </div>
                  </div>
                ))}
              </div>

              {/* Mobile Lay Page */}
              <div className="min-w-full w-full h-full grid grid-cols-3 gap-x-[1px] px-[1px] py-[1px] snap-start">
                {odds.slice(3, 6).map((odd, index) => (
                  <div
                    key={`mobile-lay-${odd.level}-${index}`}
                    className="w-full h-full min-w-0"
                  >
                    <div className="overflow-hidden relative w-full h-full px-1 py-[1px] rounded-sm flex flex-col items-center justify-center bg-bg_color_layBtnBg text-text_color_oddValue">
                      <span className="flex items-center justify-center w-full leading-5 text-sm font-semibold truncate">
                        {odd.price}
                      </span>

                      <span className="flex items-center justify-center w-full text-[9px] leading-3 text-center truncate">
                        {odd.size}
                      </span>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ) : (
            /* DESKTOP:
       All 6 odds visible together
    */
            <div className="w-full h-full grid grid-cols-6 gap-x-[1px] px-[1px] py-[1px]">
              {odds.map((odd, index) => {
                const isBack = odd.type === "back";

                return (
                  <div
                    key={`desktop-${odd.type}-${odd.level}-${index}`}
                    className="w-full h-full min-w-0"
                  >
                    <div
                      className={`overflow-hidden relative w-full h-full px-1 py-[1px] rounded-sm flex flex-col items-center justify-center text-text_color_oddValue ${
                        isBack
                          ? "bg-bg_color_backBtnBg"
                          : "bg-bg_color_layBtnBg"
                      }`}
                    >
                      <span className="flex items-center justify-center w-full leading-5 text-[15px] font-semibold truncate">
                        {odd.price}
                      </span>

                      <span className="flex items-center justify-center w-full text-[10px] leading-3 text-center truncate">
                        {odd.size}
                      </span>
                    </div>
                  </div>
                );
              })}
            </div>
          )}
        </div>
      </div>
    </Link>
  );
};

export default TableRow;
